import Joi from 'joi';
import Amount from '../types/amount';

const TransactionAmount = Joi.object().keys({
  transactionAmount: Amount,
  transactionCurrencyCode: Joi.string()
    .max(4)
    .allow('')
});

export default TransactionAmount;
